<template>
    <div v-if="loaded">
        <div v-if="showEmpty" class="table-responsive">
            <template v-if="isMobile">
                <div v-for="invoice in invoices" :key="invoice.id" class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">{{ invoice.invoice_id }}</h5>
                        <p class="card-text">{{ invoice.description ? invoice.description : invoice.name }}</p>
                        <p class="card-text">{{ invoice.due_date_duplicate ?
                            $moment(invoice.due_date_duplicate).format('DD/MM/YYYY') :
                            $moment(invoice.due_date).format('DD/MM/YYYY')}}</p>
                        <p class="card-text">{{ invoice.value }}</p>
                        <p class="card-text">
                            <i :class="[statusInvoice(invoice.status).icon, statusInvoice(invoice.status).class]"></i>
                            <span class="status">{{ statusInvoice(invoice.status).name }}</span>
                        </p>
                        <a :href="`/app/financial/invoice/${invoice.id}`"
                            class="btn btn-success">{{ $t('billing.invoice.show') }}</a>
                    </div>
                </div>
            </template>
            <template v-else>
                <!-- Mantém a tabela para desktop -->
                <table class="table align-items-center">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col"># {{ $t('billing.invoice.hash') }}</th>
                            <th scope="col">{{ $t('billing.invoice.descrition') }}</th>
                            <th scope="col" data-sort="due_date" @click="onSort('due_date')">{{ $t('common.due') }}</th>
                            <th scope="col" data-sort="value" @click="onSort('value')">
                                {{ $t('common.value') }}
                            </th>
                            <th scope="col" data-sort="status" @click="onSort('status')">{{ $t('common.status') }}</th>
                            <th class="text-center" scope="col">{{ $t('common.details') }}</th>
                        </tr>
                    </thead>
                    <tbody class="list">
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <th scope="row">
                                <div class="media align-items-center">
                                    <div class="media-body">
                                        <span class="name mb-0 text-sm">{{ invoice.invoice_id }}</span>
                                    </div>
                                </div>
                            </th>
                            <td class="budget">
                                {{ invoice.description ? invoice.description : invoice.name }}
                            </td>
                            <td>
                                {{ invoice.due_date_duplicate ? $moment(invoice.due_date_duplicate).format('DD/MM/YYYY')
                                    : $moment(invoice.due_date).format('DD/MM/YYYY')}}
                            </td>
                            <td>
                                {{ invoice.value }}
                            </td>
                            <td>
                                <i
                                    :class="[statusInvoice(invoice.status).icon, statusInvoice(invoice.status).class]"></i>
                                <span class="status">{{ statusInvoice(invoice.status).name }}</span>
                            </td>
                            <td class="text-center">
                                <a class="btn btn-success" :href="`/app/financial/invoice/${invoice.id}`" role="button">
                                    <span>{{ $t('billing.invoice.show') }}</span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <div class="card-footer py-4">
                <div
                    class="pagination-container d-flex flex-column flex-md-row align-items-center justify-content-between">
                    <div class="pagination-info">
                        <span>{{ metaStatus }}</span>
                    </div>
                    <div class="pagination-buttons mt-3 mt-md-0">
                        <base-pagination class="mb-0" v-if="meta" :page-count="meta.last_page"
                            v-model="meta.current_page" @input="onChangePage" :visible-pages="isMobile ? 3 : 7"
                            type="#525F7F">
                        </base-pagination>
                    </div>
                </div>
            </div>

        </div>
        <Empty class="my-6" v-else :color="color" :icon="'fa-search-dollar'">
            <template #title><h1 class="font-weight-medium mb-0">{{ $t('empty.unique_invoice_title') }}</h1></template>
            <template #subtitle><p>{{ $t('empty.unique_invoice_subtitle') }}</p></template>
        </Empty>
    </div>
</template>


<script>
import Dropdown from '../Common/Dropdown';
import BasePagination from '../../argon/components/BasePagination';
import Empty from '../Common/Empty';
import Invoice from '../../mixins/invoice';

export default {
    name: 'InvoiceTableUnique',
    components: {
        BasePagination,
        Dropdown,
        Empty,
    },
    mixins: [
        Invoice,
    ],
    data() {
        return {
            data: {},
            perPage: 5,
            column: null,
            order: 'DESC',
            filters: [],
            statusDropdown: false,
            paymentDropdown: false,
            loaded: false,
            isMobile: window.innerWidth < 1024,
        };
    },
    computed: {
        isLoaded() {
            return this.loaded;
        },
        showEmpty() {
            if (this.invoices && this.invoices.length > 0) return true;
        },
        meta() {
            return this.data.meta;
        },
        metaStatus() {
            return this.meta ?
                ` ${this.$t('common.showing')} ${this.meta.from} ${this.$t('common.to')}
                    ${this.meta.to} ${this.$t('common.of')} ${this.meta.total} ${this.$t('common.results')}` :
                '';
        },
        statusItems() {
            return [{
                name: 'Todos',
                value: -1,
                column: 'status',
            },
            {
                name: 'A vencer',
                value: 1,
                column: 'status',
            },
            {
                name: 'Pago',
                value: 0,
                column: 'status',
            },
            {
                name: 'Vencido',
                value: 2,
                column: 'status',
            },
            {
                name: 'Cancelado',
                value: 3,
                column: 'status',
            },
            {
                name: 'Processando',
                value: 4,
                column: 'status',
            },
            ];
        },
        invoices() {
            return this.data.data;
        },
        language() {
            return this.$store.getters.LANGUAGE;
        },
        color() {
            return this.$store.getters.COLOR;
        },
    },
    methods: {
        updateIsMobile() {
            this.isMobile = window.innerWidth < 1024;
        },
        getInvoices() {
            this.$loading.show();
            window.axios
                .get(`/api/app/invoices/${this.perPage}`, {
                    params: {
                        page: this.meta ? this.meta.current_page : 1,
                        column: this.column,
                        order: this.order,
                        filters: this.filters,
                    },
                })
                .then((res) => {
                    this.data = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.$loading.close();
                    this.loaded = true;
                });
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.getInvoices();
        },
        onSort(column) {
            this.column = column;
            this.order = this.order === 'DESC' ? 'ASC' : 'DESC';
            this.getInvoices();
        },
        onFilter(item) {
            this.closeStatusDropdown();
            this.closePaymentDropdown();

            if (!this.filters.length) {
                this.filters.push(item);

                return this.getInvoices();
            }

            const filters = this.filters.map((filter) => {
                if (filter.column === item.column) {
                    return item;
                }
                return filter;
            });

            this.filters = filters;
            this.getInvoices();
        },
        closeStatusDropdown() {
            this.statusDropdown = false;
        },
        closePaymentDropdown() {
            this.paymentDropdown = false;
        },
    },
    mounted() {
        this.getInvoices();
        window.addEventListener('resize', this.updateIsMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateIsMobile);
    },
};
</script>

<style>
.card {
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}

.card-body {
    padding: 1rem;
}

.card-title {
    margin-bottom: 0.75rem;
    font-size: 1.25rem;
}

.pagination-container {
    display: flex;
    flex-direction: column; /* Padrão: Coloca o texto acima dos botões */
    align-items: center;
}

.pagination-info {
    text-align: center; /* Centraliza o texto */
}

.pagination-buttons {
    width: 100%; /* Garante que os botões ocupem a largura total no mobile */
    display: flex;
    justify-content: center;
}

@media (min-width: 1024px) {
    .pagination-container {
        flex-direction: row; /* Em telas maiores, os elementos ficam lado a lado */
        justify-content: space-between;
    }

    .pagination-info {
        text-align: left;
    }

    .pagination-buttons {
        justify-content: flex-end;
    }
}

</style>
